module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-banner.a60c84a3.png";